module.exports = __webpack_public_path__ + "static/media/device.4d235d8b.svg";